<template>
    <div class="query-sort-area">
        <div class="basic-block" :class="[extraExpanded ? 'show-more' : '']">
            <!-- 基本查询项 -->
            <div class="query-items">
                <template v-for="queryField in basicQueryFields">
                    <swb-query-text-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Text'" :key="queryField.code" @Enter="handleEnterKey(queryField.code, $event)"
                                          v-model="filterItems[queryField.code]"
                                          :disabled="queryField.disabled"
                                          :valueType="queryField.valueType" :label="queryField.label" :placeholder="queryField.placeholder" :iniValue="queryField.value"></swb-query-text-field>
                    <swb-query-date-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Date'" :key="queryField.code" v-model="filterItems[queryField.code]" :disabled="queryField.disabled"
                                          :time="queryField.time"
                                          :valueType="queryField.valueType" :label="queryField.label" :iniValue="queryField.value" @valueformat="syncValueFormat(queryField.code, $event)"></swb-query-date-field>
                    <swb-query-date2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Date2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                           :disabled="queryField.disabled"
                                           :time="queryField.time"
                                           :valueType="queryField.valueType" :label="queryField.label" :iniValue="queryField.value" @valueformat="syncValueFormat(queryField.code, $event)"></swb-query-date2-field>
                    <swb-query-time2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Time2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                           :disabled="queryField.disabled" :valueType="queryField.valueType"
                                           :label="queryField.label" :iniValue="queryField.value"></swb-query-time2-field>
                    <swb-query-month-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Month'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                           :disabled="queryField.disabled" :valueType="queryField.valueType"
                                           :label="queryField.label" :iniValue="queryField.value" @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-month-field>
                    <swb-query-month2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Month2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                            :disabled="queryField.disabled" :valueType="queryField.valueType"
                                            :label="queryField.label" :iniValue="queryField.value"></swb-query-month2-field>
                    <swb-query-select-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Select'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                            :disabled="queryField.disabled" :valueType="queryField.valueType"
                                            :label="queryField.label" :dataList="queryField.dataList" :iniValue="queryField.value" :dataLabel="queryField.dataLabel" :dataValue="queryField.dataValue"
                                            :filterable="queryField.filterable == null ? false : queryField.filterable" :firstOnClear="queryField.firstOnClear == null ? false : queryField.firstOnClear"
                                            :multiple="queryField.multiple == null ? false : queryField.multiple" :multipleLimit="queryField.multipleLimit == null? 0 : queryField.multipleLimit"
                                            :collapseTags="queryField.collapseTags == null ? true : queryField.collapseTags" :firstIsMutex="queryField.firstIsMutex == null ? false : queryField.firstIsMutex"
                                            @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-select-field>
                    <swb-query-casc-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Casc'" :key="queryField.code" v-model="filterItems[queryField.code]" :disabled="queryField.disabled"
                                          :valueType="queryField.valueType"
                                          :label="queryField.label" :dataList="queryField.dataList" :filterable="queryField.filterable == null ? false : queryField.filterable"
                                          :multiple="queryField.multiple == null ? false : queryField.multiple" :collapseTags="queryField.collapseTags == null ? true : queryField.collapseTags"
                                          @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-casc-field>
                    <swb-query-checkbox-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Checkbox'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                              :disabled="queryField.disabled" :valueType="queryField.valueType"
                                              :label="queryField.label" :iniValue="queryField.value" @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-checkbox-field>
                    <swb-query-radiogroup-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'RadioGroup'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                                :disabled="queryField.disabled" :valueType="queryField.valueType"
                                                :label="queryField.label" :dataList="queryField.dataList" :iniValue="queryField.value" :dataLabel="queryField.dataLabel" :dataValue="queryField.dataValue"
                                                @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-radiogroup-field>
                    <swb-query-num-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Num'" :key="queryField.code" v-model="filterItems[queryField.code]" :disabled="queryField.disabled"
                                         :valueType="queryField.valueType"
                                         :label="queryField.label" :iniValue="queryField.value"></swb-query-num-field>
                    <swb-query-num2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Num2'" :key="queryField.code" v-model="filterItems[queryField.code]" :disabled="queryField.disabled"
                                          :valueType="queryField.valueType"
                                          :label="queryField.label" :iniValue="queryField.value"></swb-query-num2-field>
                    <swb-query-popup-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Popup'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                           :disabled="queryField.disabled" :valueType="queryField.valueType"
                                           :label="queryField.label" :iniValue="queryField.value" :iniText="queryField.text" @change="callEventHandlerForPopup(queryField.code, 'change', $event)"
                                           @popup="triggerPopupHandler(queryField.code, $event)"></swb-query-popup-field>
                </template>

                <!--额外查询项-->
                <template v-if="advQueryMode && extraExpanded && extraQueryFields.length > 0">
                    <template v-for="queryField in extraQueryFields">
                        <swb-query-text-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Text'" :key="queryField.code" @Enter="handleEnterKey(queryField.code, $event)"
                                              v-model="filterItems[queryField.code]"
                                              :disabled="queryField.disabled" :valueType="queryField.valueType" :label="queryField.label" :placeholder="queryField.placeholder" :iniValue="queryField.value"></swb-query-text-field>
                        <swb-query-date-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Date'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                              :disabled="queryField.disabled" :time="queryField.time"
                                              :valueType="queryField.valueType" :label="queryField.label" :iniValue="queryField.value" @valueformat="syncValueFormat(queryField.code, $event)"></swb-query-date-field>
                        <swb-query-date2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Date2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                               :disabled="queryField.disabled" :time="queryField.time"
                                               :valueType="queryField.valueType" :label="queryField.label" :iniValue="queryField.value" @valueformat="syncValueFormat(queryField.code, $event)"></swb-query-date2-field>
                        <swb-query-time2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Time2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                               :disabled="queryField.disabled" :valueType="queryField.valueType"
                                               :label="queryField.label" :iniValue="queryField.value"></swb-query-time2-field>
                        <swb-query-month-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Month'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                               :disabled="queryField.disabled" :valueType="queryField.valueType"
                                               :label="queryField.label" :iniValue="queryField.value" @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-month-field>
                        <swb-query-month2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Month2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                                :disabled="queryField.disabled" :valueType="queryField.valueType"
                                                :label="queryField.label" :iniValue="queryField.value"></swb-query-month2-field>
                        <swb-query-select-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Select'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                                :disabled="queryField.disabled" :valueType="queryField.valueType"
                                                :label="queryField.label" :dataList="queryField.dataList" :iniValue="queryField.value" :dataLabel="queryField.dataLabel" :dataValue="queryField.dataValue"
                                                :filterable="queryField.filterable == null ? false : queryField.filterable" :firstOnClear="queryField.firstOnClear == null ? false : queryField.firstOnClear"
                                                :multiple="queryField.multiple == null ? false : queryField.multiple" :multipleLimit="queryField.multipleLimit == null? 0 : queryField.multipleLimit"
                                                :collapseTags="queryField.collapseTags == null ? true : queryField.collapseTags" :firstIsMutex="queryField.firstIsMutex == null ? false : queryField.firstIsMutex"
                                                @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-select-field>
                        <swb-query-casc-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Casc'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                              :disabled="queryField.disabled" :valueType="queryField.valueType"
                                              :label="queryField.label" :dataList="queryField.dataList" :filterable="queryField.filterable == null ? false : queryField.filterable"
                                              :multiple="queryField.multiple == null ? false : queryField.multiple" :collapseTags="queryField.collapseTags == null ? true : queryField.collapseTags"
                                              @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-casc-field>
                        <swb-query-checkbox-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Checkbox'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                                  :disabled="queryField.disabled" :valueType="queryField.valueType"
                                                  :label="queryField.label" :iniValue="queryField.value" @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-checkbox-field>
                        <swb-query-radiogroup-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'RadioGroup'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                                    :disabled="queryField.disabled" :valueType="queryField.valueType"
                                                    :label="queryField.label" :dataList="queryField.dataList" :iniValue="queryField.value" :dataLabel="queryField.dataLabel" :dataValue="queryField.dataValue"
                                                    @change="callEventHandler(queryField.code, 'change', $event)"></swb-query-radiogroup-field>
                        <swb-query-num-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Num'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                             :disabled="queryField.disabled" :valueType="queryField.valueType"
                                             :label="queryField.label" :iniValue="queryField.value"></swb-query-num-field>
                        <swb-query-num2-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Num2'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                              :disabled="queryField.disabled" :valueType="queryField.valueType"
                                              :label="queryField.label" :iniValue="queryField.value"></swb-query-num2-field>
                        <swb-query-popup-field :ref="makeQueryFieldVueCtrlName(queryField.code)" v-if="!queryField.hidden && queryField.type == 'Popup'" :key="queryField.code" v-model="filterItems[queryField.code]"
                                               :disabled="queryField.disabled" :valueType="queryField.valueType"
                                               :label="queryField.label" :iniValue="queryField.value" :iniText="queryField.text" @change="callEventHandler(queryField.code, 'change', $event)"
                                               @popup="triggerPopupHandler(queryField.code, $event)"></swb-query-popup-field>
                    </template>
                </template>
            </div>
            <div class="sort-btn-group mt10" v-show="extraExpanded">
                <template v-for="sortField in enabledSortFields">
                    <swb-query-sort-field v-model="sortItems[sortField.code]" :key="sortField.code" :label="sortField.label" :order="sortField.order" @sortFieldChanged="handleSortFieldChange(sortField.code, $event)"
                                          @sortFieldDisabled="disableSortField(sortField.code)"></swb-query-sort-field>
                </template>
            </div>
            <!-- 查询按钮 -->
            <div class="query-btns" :class="[extraExpanded ? 'show-more' : '']">
                <div class="operation-btn-group">
                    <div class="query-btn" @click="callQueryHanlder()">查询</div>
                    <div class="senior-btn" @click="switchExtraBlock" title="高级">
                        <i class="icon iconfont" :class="[extraExpanded ? 'icon-double-arrow-up' : 'icon-double-arrow-down']"></i>
                    </div>
                </div>
                <div v-if="extraExpanded && custConfEnabled && mountedFlag" class="other-more">
                    <el-link icon="el-icon-set-up" style="font-size:12px;" @click="showQueryConfUI($event)">查询设置</el-link>
                    <el-divider direction="vertical" v-if="haveSortFields"></el-divider>
                    <el-link v-if="haveSortFields" class="mr10" icon="el-icon-set-up" style="font-size:12px;" @click="showSortConfUI($event)">排序设置</el-link>
                    <span v-show="hisQueryBtnVisible()">
                         <el-divider direction="vertical"></el-divider>
                        <el-link class="mr10" icon="el-icon-orange" style="font-size:12px;" @click="showHisRecordsViewDlg">历史查询</el-link>
                    </span>
                </div>
            </div>
        </div>
        <!-- 查询设置弹出框 -->
        <swb-dt-popover v-if="custConfEnabled" ref="queryConfPopover" placement="right-start" v-model="queryConfUIVisible" @show="syncQueryConfUIVisible(true)" @hide="syncQueryConfUIVisible(false)">
            <swb-query-field-conf ref="queryConfRef" :forHisQry="forHisQry" :showExtBtns="showConfExtBtns" :custSavable="isCustStorable()" :onConfirm="onQueryConfConfirm" :onClose="onQueryConfCancel" :onSaveCustConf="onSaveQueryConfInfo"
                                  :basicMaxSpaces="basicMaxSpaces" :metaQueryFields="liveQueryFields" :custQueryFields="custQueryFields"></swb-query-field-conf>
        </swb-dt-popover>
        <!-- 排序设置弹出框 -->
        <swb-dt-popover v-if="custConfEnabled" ref="sortConfPopover" placement="right-start" v-model="sortConfUIVisible" @show="syncSortConfUIVisible(true)" @hide="syncSortConfUIVisible(false)">
            <swb-sort-field-conf ref="sortConfRef" :forHisQry="forHisQry" :showExtBtns="showConfExtBtns" :custSavable="isCustStorable()" :onConfirm="onSortConfConfirm" :onClose="onSortConfCancel" :onSaveCustConf="onSaveSortConfInfo"
                                 :metaSortFields="liveSortFields" :custSortFields="custSortFields"></swb-sort-field-conf>
        </swb-dt-popover>
    </div>
</template>

<script>
    // last modified by koqiui
    import {Utils, $} from '../../app.base'
    import {Vue, toDependedNodeMap, castToJsonArray, convertToTypedValue, getQueryResultConfStorer} from '../../app.vues'

    import SwbQueryTextField from './QueryTextField';

    Vue.regist(SwbQueryTextField);

    import SwbQueryDateField from './QueryDateField.vue';
    import {formatIntegerDate} from './QueryDateField';

    Vue.regist(SwbQueryDateField);

    import SwbQueryDate2Field from './QueryDate2Field';

    Vue.regist(SwbQueryDate2Field);

    import SwbQueryTime2Field from './QueryTime2Field.vue';

    Vue.regist(SwbQueryTime2Field);

    import SwbQueryMonthField from './QueryMonthField.vue';
    import {formatYearMonth} from './QueryMonthField';

    Vue.regist(SwbQueryMonthField);

    import SwbQueryMonth2Field from './QueryMonth2Field.vue';

    Vue.regist(SwbQueryMonth2Field);

    import SwbQuerySelectField from './QuerySelectField';

    Vue.regist(SwbQuerySelectField);

    import SwbQueryCascField from './QueryCascField.vue';

    Vue.regist(SwbQueryCascField);

    import SwbQueryCheckboxField from './QueryCheckboxField';

    Vue.regist(SwbQueryCheckboxField);

    import SwbQueryRadiogroupField from './QueryRadioGroupField';

    Vue.regist(SwbQueryRadiogroupField);

    import SwbQueryNumField from './QueryNumField';

    Vue.regist(SwbQueryNumField);

    import SwbQueryNum2Field from './QueryNum2Field';

    Vue.regist(SwbQueryNum2Field);

    import SwbQueryPopupField from './QueryPopupField.vue';

    Vue.regist(SwbQueryPopupField);

    import SwbQuerySortField from './QuerySortField';

    Vue.regist(SwbQuerySortField);

    import SwbDtPopover from '../ctrl/DtPopover.vue'

    Vue.regist(SwbDtPopover);

    import {extractCustQueryFieldInfo, reserveMergeQueryArray} from './QueryFieldConf.vue';
    import SwbQueryFieldConf from './QueryFieldConf';

    Vue.regist(SwbQueryFieldConf);

    import {extractCustSortFieldInfo, reserveMergeSortArray} from './SortFieldConf.vue';
    import SwbSortFieldConf from './SortFieldConf';

    Vue.regist(SwbSortFieldConf);

    // --------------------------------
    // callback(success , message || data::{ queryFields, sortFields })
    // ConfStorer.loadMetaQueryConf(key, callback);//仅仅获取查询配置

    // callback(success , message || data::{ colList })
    // ConfStorer.loadMetaResultConf(key, callback);//仅仅获取结果配置

    // callback(success , message || data::{query : { queryFields, sortFields } , result : { colList }, results : { key1 : result1, key2 : result2}})
    // ConfStorer.loadMetaQueryResultConf(key, callback);同时获取查询+结果配置(key为query的)
    //------------
    // callback(success , message || data::{ queryFields, sortFields })
    // ConfStorer.loadCustQueryConf(key, callback)
    // callback(success, message)
    // ConfStorer.saveCustQueryConf(key, custConf, callback)

    // callback(success , message || data::{ colList })
    // ConfStorer.loadCustResultConf(key, callback)
    // callback(success, message)
    // ConfStorer.saveCustResultConf(key, custConf, callback);

    function getQueryConfStorer() {
        return getQueryResultConfStorer();
    }

    //--------------------------------
    let __hisRecordsViewDlgFunc = null;

    // 设置历史查询对话框查看函数
    export function setHisRecordsViewDlgFunc(hisRecordsViewDlgFunc) {
        if (typeof hisRecordsViewDlgFunc == 'function') {
            __hisRecordsViewDlgFunc = hisRecordsViewDlgFunc;
        } else {
            console.error('hisRecordsViewDlgFunc 必须是函数');
        }
    }

    // --------------------------------
    function deepCloneArray(arr) {
        arr = arr || [];
        return arr.map(function (elem) {
            return Utils.merge({}, elem);
        });
    }

    //数据列表转为valueMap
    function dataListToValMap(dataList, valueProp, valsMap, forCasc) {
        dataList = dataList || [];
        if (forCasc) {
            let dataItem = null;
            let children = null;
            for (let i = 0, c = dataList.length; i < c; i++) {
                dataItem = dataList[i];
                //
                valsMap[dataItem[valueProp] + ''] = dataItem;
                //
                children = dataItem.children || null;
                if (children != null && Utils.isArray(children) && children.length > 0) {
                    dataListToValMap(children, valueProp, valsMap);
                }
            }
        } else {
            Utils.merge(valsMap, dataList.toMap(valueProp));
        }
    }

    function extractTextFromDataListByValue(multi, dataList, value, datalabel, dataValue, forCasc) {
        dataList = dataList || [];
        datalabel = datalabel || 'label';
        dataValue = dataValue || 'value';
        forCasc = forCasc == true;
        //
        let valsMap = {};
        dataListToValMap(dataList, dataValue, valsMap, forCasc);
        if (multi) {
            let values = value || [];
            let textItems = [];
            for (let i = 0, c = values.length; i < c; i++) {
                let valStr = values[i] + '';
                let dataItem = valsMap[valStr];
                if (dataItem != null) {
                    textItems.push(dataItem[datalabel]);
                }
            }
            return textItems.length > 0 ? textItems.join('、') : null;
        } else {
            let dataItem = null;
            if (value == null) {
                let retText = null;
                for (let i = 0, c = dataList.length; i < c; i++) {
                    dataItem = dataList[i];
                    if (dataItem[dataValue] == null) {
                        retText = dataItem[datalabel];
                        break;
                    }
                }
                return retText;
            } else {
                dataItem = valsMap[value + ''];
                return dataItem == null ? null : dataItem[datalabel];
            }
        }
    }

    function keepDynaDataLists(queryFields, dynaDataLists) {
        queryFields = queryFields || [];
        dynaDataLists = dynaDataLists || {};
        for (let i = 0, c = queryFields.length; i < c; i++) {
            let field = queryFields[i];
            let code = field.code;
            let type = field.type;
            let dataList = dynaDataLists[code];
            if (dataList && (type == 'Select' || type == 'RadioGroup' || type == 'Casc')) {
                field.dataList = dataList;
            }
        }
    }

    function keepFilterItemValues(queryFields, prevValues) {
        queryFields = queryFields || [];
        prevValues = prevValues || {};
        if (!Utils.isEmptyObject(prevValues)) {
            for (let i = 0, c = queryFields.length; i < c; i++) {
                let field = queryFields[i];
                let code = field.code;
                //
                let value = prevValues[code];
                if (typeof value !== 'undefined') {
                    field.value = value;
                }
            }
        }
    }

    function clearFilterItemValues(queryFields) {
        queryFields = queryFields || [];
        for (let i = 0, c = queryFields.length; i < c; i++) {
            let field = queryFields[i];
            delete field.value;
            delete field.text;
        }
    }

    //
    const default_basicMaxSpaces = 20;
    let CondMonitor = Utils.CondMonitor;
    //
    export default {
        name: 'swb-query-sort-area',
        desc: '综合查询条件、排序信息',
        //
        custTag: 'QuerySortArea',//自定义属性（用于自定义判断）
        //
        props: {
            forHisQry: {//是否历史查询模式
                type: Boolean,
                default: false
            },
            confKey: {//自定义配置加载/保存key
                type: String
            },
            custConfEnabled: {//是否支持自定义调整
                type: Boolean,
                default: true
            },
            //----------------------------------
            //查询排序元设信息
            config: null,
            /*{
                type: Object,
                default: {
                    //基本区域最大单元数量
                    basicMaxSpaces: default_basicMaxSpaces,
                    //查询项配置
                    queryFields: [],
                    //排序项配置
                    sortFields: [],
                }
            }*/
            configAuto: {//是否根据confKey自动获取元数据配置
                type: Boolean,
                default: false
            },
            onConfigReady: {//配置加载完成回调函数(this)
                type: Function,
                default: null
            },
            //mounted 后的回调函数(this)
            mountedHandler: {
                type: Function,
                default: null
            },
            //查询回调函数调用上下文对象
            queryContext: null,
            //查询回调函数({filterItems, sortItemList, sortItems})
            queryHandler: {
                type: Function
            },
            queryOnEnter: {//文本框回车是否触发查询
                type: Boolean,
                default: true
            },
            // 弹出选择的click处理函数(fieldCode, curValue, curText)
            popupHandler: {
                type: Function
            },
            //加载后是否自动触发查询一次
            queryOnLoad: {
                type: Boolean,
                default: false
            },
            //查询组件事件处理函数(itemCode, eventName, itemValue, filterItems, dependerCodes)
            eventHandler: {
                type: Function
            },
            //是否有历史查询权限
            showHisQuery: {
                type: Boolean,
                default: true
            },
            //需要排除上下文名称（参考 同目录下 Cmn.js的 name）
            excludeHisQueryCtxNames: {
                type: Array,
                default: null
            }
        },
        //
        data() {
            return {
                mountedFlag: false,
                //
                suspending: false,
                currEvents: {},
                //加载后自动查询是否已触发过了
                initQueryDone: false,
                // 初始查询字段值
                initFieldValues: {},
                //
                basicMaxSpaces: default_basicMaxSpaces,
                metaQueryFields: [],
                metaSortFields: [],
                //
                custQueryFields: [],
                custSortFields: [],
                //自定义信息是加载状态：0 未开始，1 加载中, 2 加载完毕
                custInfoLoadState: 0,
                //
                liveQueryFields: [],
                liveSortFields: [],
                //
                basicQueryFields: [],
                basicMapIndexes: {},//code => index
                extraQueryFields: [],
                extraMapIndexes: {},//code => index
                //
                haveSortFields: false,
                //
                mappedQueryFields: {},//code => field
                //
                dependeeCodes: [],// dependee code list
                dependerLastTs: {},
                dependerCodesMap: {}, // dependee code => depender code
                //-------------------
                advQueryMode: false,
                extraExpanded: false,
                //范围字段代码列表
                rangedFieldNames: [],
                //-------------------
                showConfExtBtns: true,
                //
                queryConfUIVisible: false,
                //
                enabledSortFields: [],
                //排序设置弹出框是否可见
                sortConfUIVisible: false,
                //-------------------
                dynaDataLists: {},//动态dataList
                filterItems: {},
                sortItems: {},
                //查询条件格式
                formatItems: {},
                //最后一次点击查询时的缓存
                lastQueryFilterItems: null,
                //是否绑定了历史查询
                hisQueryBound: false,
                //绑定的历史查询配置
                hisQueryId: null,
                hisQueryName: ''
            };
        },
        watch: {
            confKey(newVal, oldVal) {
                this.dynaDataLists = {};
                this.filterItems = {};
                this.sortItems = {};
                this.formatItems = {};
                //
                this.custInfoLoadState = 0;
                //
                if (this.configAuto) {
                    this.autoLoadConf(true);
                } else {
                    this.prepare();
                }
            },
            config(newVal, oldVal) {
                this.dynaDataLists = {};
                this.filterItems = {};
                this.sortItems = {};
                this.formatItems = {};
                //
                this.custInfoLoadState = 0;
                //
                this.prepare();
            }
        },
        //
        computed: {},
        //
        created() {
            this.eventDelayer = new Utils.TaskDelayer();
            //--------------------------------------------------------------
            if (this.configAuto) {
                this.autoLoadConf();
            } else {
                this.prepare();
            }
        },
        mounted() {
            this.mountedFlag = true;
            //
            this.queryConfRef = this.$refs['queryConfRef'];
            this.sortConfRef = this.$refs['sortConfRef'];
            //
            if (this.custInfoLoadState == 2) {
                if (this.suspending) {
                    //初始触发事件
                    this.eventDelayer.delay(this.notifyEvents, 1000);
                }
            } else {
                this.init();
            }
            //
            if (this.mountedHandler != null) {
                this.mountedHandler(this);
            }
        },
        beforeDestroy() {
            clearTimeout(this.initQueryTimer);
            //
            if (this.eventDelayer != null) {
                this.eventDelayer.cancel();
                this.eventDelayer = null;
            }
            //data
            this.lastQueryFilterItems = null;
            this.formatItems = null;
            this.sortItems = null;
            this.filterItems = null;
            this.dynaDataLists = null;
            this.enabledSortFields = null;
            this.rangedFieldNames = null;
            this.dependerCodesMap = null;
            this.dependerLastTs = null;
            this.dependeeCodes = null;
            this.mappedQueryFields = null;
            this.extraMapIndexes = null;
            this.extraQueryFields = null;
            this.basicMapIndexes = null;
            this.basicQueryFields = null;
            this.liveSortFields = null;
            this.liveQueryFields = null;
            this.custSortFields = null;
            this.custQueryFields = null;
            this.metaSortFields = null;
            this.metaQueryFields = null;
            this.initFieldValues = null;
            this.basicMaxSpaces = null;
            this.currEvents = null;
            //comp
            this.queryConfRef = null;
            this.sortConfRef = null;
        },
        //
        methods: {
            makeQueryFieldVueCtrlName(fieldCode) {
                return 'query-field-vue-ctrl-' + fieldCode;
            },
            //是否显示历史查询
            hisQueryBtnVisible() {
                return this.showHisQuery && this.hisQueryBound;
            },
            isCustStorable() {//自定义是否可以保存
                return this.custConfEnabled && this.confKey != null;
            },
            autoLoadConf(refreshMeta = false) {
                if (this.config == null || refreshMeta) {
                    if (this.$confStorer == null) {
                        console.error('$confStorer未配置，无法自动获取元数据配置');
                    } else {
                        let self = this;
                        this.$confStorer.loadMetaQueryConf(this.confKey, function (success, metaConf) {
                            if (success) {
                                console.debug('自动获取查询元数据配置成功');
                                // 历史查询
                                let hisQueryId = metaConf.hisQueryConfId;
                                if (hisQueryId != null && hisQueryId > 0) {
                                    console.info('------------------ 历史查询配置 -----------------');
                                    let hisQueryName = metaConf.hisQueryConfName;
                                    console.info(hisQueryId + ' : ' + hisQueryName);
                                    self.hisQueryBound = true;
                                    self.hisQueryId = hisQueryId;
                                    self.hisQueryName = hisQueryName;
                                } else {
                                    self.hisQueryBound = false;
                                    self.hisQueryId = null;
                                    self.hisQueryName = null;
                                }
                                //
                                self.prepare(metaConf);
                            } else {
                                console.error('自动获取元数据配置失败：' + metaConf);
                            }
                        });
                    }
                }
            },
            loadCustInfo(thenCallback) {
                if (this.custInfoLoadState == 0) {//加载自定义配置信息
                    this.custInfoLoadState = 1;
                    if (this.isCustStorable()) {
                        //获取自定义信息
                        let custStorer = getQueryConfStorer();
                        if (custStorer == null) {
                            this.custQueryFields = [];
                            this.custSortFields = [];
                            this.custInfoLoadState = 2;
                            console.error('自定义信息配置访问器未设置');
                            //
                            thenCallback();
                        } else {
                            let self = this;
                            custStorer.loadCustQueryConf(this.confKey, function (success, config) {
                                self.custInfoLoadState = 2;
                                //
                                if (success) {
                                    config = config || {};
                                    self.custQueryFields = castToJsonArray(config.queryFields);
                                    self.custSortFields = castToJsonArray(config.sortFields);
                                    console.debug('---- 上次的自定义查询配置（key : ' + self.confKey + '） ----');
                                    console.debug(self.custQueryFields);
                                    console.debug(self.custSortFields);
                                } else {
                                    self.custQueryFields = [];
                                    self.custSortFields = [];
                                    //
                                    self.$message({
                                        type: 'warning',
                                        message: config
                                    });
                                }
                                //
                                thenCallback();
                            });
                        }
                    } else {
                        this.custQueryFields = [];
                        this.custSortFields = [];
                        this.custInfoLoadState = 2;
                        //
                        thenCallback();
                    }
                }
            },
            prepare(config) {
                config = config || this.config || null;
                //从元数据配置提取动态标签字段信息
                let tagMetaRoleTableList = [];
                let dynaTagFieldsMap = {};//动态标签字段名 => 字段信息缓存

                let self = this;

                if (config != null) {
                    this.basicMaxSpaces = config.basicMaxSpaces || default_basicMaxSpaces;
                    //
                    console.debug('---- 平台预设的元查询配置（code : ' + config.code + '）----');
                    //
                    let queryFields = castToJsonArray(config.queryFields || []);
                    let sortFields = castToJsonArray(config.sortFields || []);
                    //
                    this.metaQueryFields = queryFields;
                    console.debug(this.metaQueryFields);
                    this.metaSortFields = sortFields;
                    console.debug(this.metaSortFields);

                    //
                    let uniqueMap = {}; //防重临时缓存
                    for (let i = 0, c = queryFields.length; i < c; i++) {
                        let tmpItem = queryFields[i];
                        if (tmpItem.dynaTag) {
                            dynaTagFieldsMap[tmpItem.code] = tmpItem;
                            //防重临时键
                            let tmpKey = tmpItem.tagMetaRole + ':' + tmpItem.tagMetaTableName;
                            if (uniqueMap[tmpKey] == null) {
                                uniqueMap[tmpKey] = 1;
                                tagMetaRoleTableList.push({
                                    tagMetaRole: tmpItem.tagMetaRole,
                                    tagMetaTableName: tmpItem.tagMetaTableName
                                });
                            }
                        }
                    }
                }

                //融合配置并初始化
                function mergeConfAndInit() {
                    self.liveQueryFields = reserveMergeQueryArray(self.custQueryFields, self.metaQueryFields, 'code');
                    //补全自定义信息
                    self.custQueryFields = self.liveQueryFields.map(function (field) {
                        return extractCustQueryFieldInfo(field);
                    });

                    self.liveSortFields = reserveMergeSortArray(self.custSortFields, self.metaSortFields, 'code');
                    //补全自定义信息
                    self.custSortFields = self.liveSortFields.map(function (field) {
                        return extractCustSortFieldInfo(field);
                    });
                    //
                    self.init();
                    //
                    if (self.onConfigReady) {
                        self.onConfigReady(self);
                    } else {
                        console.debug('查询配置加载完毕');
                    }
                }

                //
                if (tagMetaRoleTableList.length > 0) {
                    if (this.$confStorer != null) {
                        this.$confStorer.loadCustTagMetaFields(tagMetaRoleTableList, function (success, tagMetaFields) {
                            //console.log(tagMetaFields);
                            //
                            let namesToDel = []; //要删除的名称
                            for (let name in dynaTagFieldsMap) {
                                let metaField = dynaTagFieldsMap[name];
                                let tagField = tagMetaFields.find(function (tagMeta, index) {
                                    return tagMeta.tagMetaRole == metaField.tagMetaRole && tagMeta.tableName == metaField.tagMetaTableName && tagMeta.fieldName == metaField.code;
                                });
                                if (tagField != null) {
                                    if (tagField.enabled) {
                                        //动态Label
                                        metaField.label = tagField.dispName;
                                        //动态数据列表
                                        let itemList = tagField.itemList || [];
                                        let dataList = itemList.map(function (item) {
                                            return {
                                                label: item.name,
                                                value: item.id
                                            };
                                        });
                                        //前插null值项
                                        dataList.unshift({
                                            label: '- 全部 -',
                                            value: null
                                        });
                                        metaField.dataList = dataList;
                                    } else {
                                        namesToDel.push(name);
                                    }
                                } else {
                                    namesToDel.push(name);
                                }
                            }
                            if (namesToDel.length > 0) {
                                //console.log('需要删除的：', namesToDel);
                                let queryFields = self.metaQueryFields;
                                for (let i = queryFields.length - 1; i >= 0; i--) {
                                    let tmpItem = queryFields[i];
                                    if (namesToDel.indexOf(tmpItem.code) != -1) {
                                        queryFields.removeAt(i);
                                        //console.log('已删除条件：' + tmpItem.code);
                                    }
                                }
                            }
                            //
                            self.loadCustInfo(mergeConfAndInit);
                        });

                    } else {
                        console.error('$confStorer未配置，无法自定义标签配置');
                        //
                        this.loadCustInfo(mergeConfAndInit);
                    }

                } else {
                    this.loadCustInfo(mergeConfAndInit);
                }
            },
            //----------------------------------------------
            handleEnterKey(fieldCode, fieldLabel) {
                if (this.queryOnEnter) {
                    this.callQueryHanlder();
                }
            },
            triggerPopupHandler(fieldCode, popupInfo = {}) {
                if (typeof this.popupHandler == 'function') {
                    this.popupHandler.call(null, fieldCode, popupInfo.value, popupInfo.text);
                }
            },
            filterDependerCodes(dependerCodes) {
                if (dependerCodes == null || dependerCodes.length == 0) {
                    return;
                }
                let lastTs = null;
                let dependerCode = null;
                let dependerLastTs = this.dependerLastTs;
                let currTs = new Date().getTime();
                for (let i = dependerCodes.length - 1; i >= 0; i--) {
                    dependerCode = dependerCodes[i];
                    lastTs = dependerLastTs[dependerCode];
                    if (lastTs == null || currTs - lastTs > 1000) {
                        dependerLastTs[dependerCode] = currTs;
                    } else {
                        dependerCodes.removeAt(i);
                    }
                }
            },
            callEventHandler(itemCode, eventName, itemValue) {
                //console.debug(itemCode + ' : ' + itemValue);
                if (this.suspending == true) {
                    this.currEvents[itemCode] = eventName;
                } else if (typeof this.eventHandler == 'function') {
                    if (typeof itemValue == 'undefined') {
                        return;
                    }
                    let dependerCodes = this.dependerCodesMap[itemCode] || null;
                    this.filterDependerCodes(dependerCodes);
                    this.eventHandler.call(null, itemCode, eventName, itemValue, this.toFilterItems(this.filterItems), dependerCodes);
                }
            },
            callEventHandlerForPopup(itemCode, eventName, itemValue) {
                let liveQueryFields = this.liveQueryFields;
                let theIndex = liveQueryFields.indexOf(itemCode, function (field) {
                    return field.code == itemCode;
                });
                itemValue = itemValue || {};
                if (theIndex != -1) {
                    let theField = liveQueryFields[theIndex];
                    let itemText = itemValue.text || null;
                    theField.text = itemText;
                    //
                    this.$set(this.liveQueryFields, theIndex, theField);
                }
                //
                this.callEventHandler(itemCode, eventName, itemValue.value);
            },
            syncValueFormat(itemCode, valueFormat) {
                this.formatItems[itemCode] = valueFormat;
                //console.log(this.formatItems);
            },
            init(falseInit /* 是否假初始化*/) {
                clearTimeout(this.initQueryTimer);
                //
                if (this.eventDelayer != null) {
                    this.eventDelayer.cancel();
                }
                this.suspending = true;
                //标记初始化开始
                this.currEvents = {};
                this.dependerLastTs = {};
                //
                let initFieldValues = {};
                this.lastQueryFilterItems = null;
                //
                let liveQueryFields = this.liveQueryFields;
                //
                keepDynaDataLists(liveQueryFields, this.dynaDataLists);
                keepFilterItemValues(liveQueryFields, this.filterItems);
                //级联依赖
                let dependCodeMap = {};
                //
                let mappedQueryFields = {};
                liveQueryFields.forEach(function (field) {
                    if (field.type == 'Date' || field.type == 'Date2') {//日期/时间格式
                        field.time = field.time == true;
                    }
                    if (field.cascName) {//暂存依赖关系
                        dependCodeMap[field.code] = field.cascName;
                        //console.debug(field.code + ' => ' + field.cascName);
                    }
                    //
                    mappedQueryFields[field.code] = field;
                });
                this.mappedQueryFields = mappedQueryFields;
                let dependerCodesMap = toDependedNodeMap(dependCodeMap);
                //
                let dependeeCodes = [];
                console.debug('----- 字段 影响/通知 关系 -----');
                liveQueryFields.forEach(function (field) {
                    if (dependerCodesMap[field.code]) {
                        dependeeCodes.push(field.code);
                        console.debug(field.label + ' ' + field.code + ' 通知：' + dependerCodesMap[field.code].join(', '));
                    }
                });
                this.dependeeCodes = dependeeCodes;
                this.dependerCodesMap = dependerCodesMap;
                //console.debug(this.dependeeCodes);
                //restore query field values
                //
                let rangedFieldNames = [];
                //查询字段
                let fieldIndex = 0;
                let basicMapIndexes = {};
                //console.debug('--------- basic query fields --------');
                this.basicQueryFields = liveQueryFields.filter(function (field) {
                    let fieldType = field.type;
                    if (fieldType == 'Date2' || fieldType == 'Time2' || fieldType == 'Month2' || fieldType == 'Num2') {
                        rangedFieldNames.push(field.code);
                    }
                    // console.log(fieldType + ':' + field.label + ' - ' + field.code + ' : ' + field.value);
                    if (typeof field.value == 'undefined') {//处理默认值
                        if (fieldType == 'RadioGroup') {
                            let dataList = field.dataList || [];
                            if (dataList.length > 0) {
                                let dataValue = field.dataValue || 'value';
                                let valueType = field.valueType;
                                let datum1st = dataList[0];
                                field.value = convertToTypedValue(datum1st[dataValue], valueType);
                            }
                        } else if (fieldType == 'Checkbox') {
                            field.value = false;
                        } else {
                            field.value = null;
                        }
                    }
                    initFieldValues[field.code] = field.value;
                    //
                    //console.log(fieldType + ':' + field.label + ' - ' + field.code + ' : ' + field.value);
                    let passed = field.basic === true;
                    if (passed) {
                        basicMapIndexes[field.code] = fieldIndex++;
                    }
                    return passed;
                });
                this.basicMapIndexes = basicMapIndexes;

                //console.debug(this.basicQueryFields);
                //console.debug(this.basicMapIndexes);

                fieldIndex = 0;
                let extraMapIndexes = {};
                //console.debug('--------- extra query fields --------');
                this.extraQueryFields = liveQueryFields.filter(function (field) {
                    let fieldType = field.type;
                    if (fieldType == 'Date2' || fieldType == 'Time2' || fieldType == 'Month2' || fieldType == 'Num2') {
                        rangedFieldNames.push(field.code);
                    }
                    //console.log(fieldType + ':' + field.label + ' - ' + field.code + ' : ' + field.value);
                    if (typeof field.value == 'undefined') {//处理默认值
                        if (fieldType == 'RadioGroup') {
                            let dataList = field.dataList || [];
                            if (dataList.length > 0) {
                                let dataValue = field.dataValue || 'value';
                                let valueType = field.valueType;
                                let datum1st = dataList[0];
                                field.value = convertToTypedValue(datum1st[dataValue], valueType);
                            }
                        } else if (fieldType == 'Checkbox') {
                            field.value = false;
                        } else {
                            field.value = null;
                        }
                    }
                    initFieldValues[field.code] = field.value;
                    //
                    //console.log(fieldType + ':' + field.label + ' - ' + field.code + ' : ' + field.value);
                    let passed = field.basic !== true;
                    if (passed) {
                        extraMapIndexes[field.code] = fieldIndex++;
                    }
                    return passed;
                });
                this.extraMapIndexes = extraMapIndexes;

                //console.debug(this.extraQueryFields);
                //console.debug(this.extraMapIndexes);

                this.rangedFieldNames = rangedFieldNames;
                //
                this.haveSortFields = this.liveSortFields.length > 0;
                //排序字段
                //console.debug('--------- enabledSortFields fields --------');
                this.enabledSortFields = this.liveSortFields.filter(function (field) {
                    return field.enabled === true;
                });
                //
                if (falseInit !== true) {
                    this.initFieldValues = initFieldValues;
                }
                //console.debug(this.enabledSortFields);
                if (this.eventDelayer != null) {
                    //初始触发事件
                    this.eventDelayer.delay(this.notifyEvents, 1000);
                }
            },
            notifyEvents(callQueryHanlderForcely) {
                this.suspending = false;
                //
                let filterItems = this.lastQueryFilterItems = this.toFilterItems(this.filterItems);
                //按依赖关系去除不必要的事件通知
                let eventName = null;
                let itemCode = null;
                let dependeeCodes = this.dependeeCodes;
                let dependerCodesMap = this.dependerCodesMap;
                let dependerCodes = null;
                for (let i = 0, c = dependeeCodes.length; i < c; i++) {
                    itemCode = dependeeCodes[i];
                    eventName = this.currEvents[itemCode];
                    if (eventName) {
                        dependerCodes = dependerCodesMap[itemCode];
                        for (let i = 0, c = dependerCodes.length; i < c; i++) {
                            delete this.currEvents[dependerCodes[i]];
                        }
                    }
                }
                //
                for (itemCode in this.currEvents) {
                    eventName = this.currEvents[itemCode];
                    delete this.currEvents[itemCode];//!!!
                    //
                    let itemValue = filterItems[itemCode];
                    //
                    this.callEventHandler(itemCode, eventName, itemValue);
                }
                //触发初次查询（如果有依赖关系会忽略queryOnLoad选项）
                if ((callQueryHanlderForcely || this.queryOnLoad && !this.initQueryDone) && dependeeCodes.length == 0) {
                    let self = this;
                    this.initQueryTimer = setTimeout(function () {
                        //console.debug('自动执触发条件查询');
                        self.initQueryDone = true;
                        //
                        self.callQueryHanlder();
                    }, 500);
                }
            },
            //
            switchExtraBlock() {
                this.advQueryMode = !this.advQueryMode;
                if (this.advQueryMode == true) {
                    if (!this.extraExpanded) {
                        this.extraExpanded = true;
                    }
                    //确保恢复隐藏字段的值
                    keepFilterItemValues(this.liveQueryFields, this.filterItems);
                } else {
                    if (this.extraExpanded) {
                        this.extraExpanded = false;
                    }
                }
            },

            //把当前排序信息同步到字段中
            syncBackSortFields() {
                let liveSortFields = this.liveSortFields;
                for (let i = 0; i < liveSortFields.length; i++) {
                    let field = liveSortFields[i];
                    let code = field.code;
                    let order = this.sortItems[code];
                    if (typeof order !== 'undefined') {
                        field.order = order;
                    }
                }
                //
                this.liveSortFields = Utils.merge([], liveSortFields);
                this.enabledSortFields = this.liveSortFields.filter(function (field) {
                    return field.enabled === true;
                });
            },
            triggerSortChange() {
                //延迟调用
                let self = this;
                setTimeout(function () {
                    self.callQueryHanlder(true);
                }, 100);
            },
            handleSortFieldChange(code, order) {
                //console.debug('sort field changed : ' + code + " = " + order);
                this.syncBackSortFields();
                //
                this.triggerSortChange();
            },
            //------------------ 查询字段调整 -------------------
            getQueryConfPopover() {
                return this.$refs['queryConfPopover'] || null;
            },
            showQueryConfUI(event) {
                let curBtn = event.currentTarget;
                //
                let queryConfPopover = this.getQueryConfPopover();
                queryConfPopover.bindToReferer(
                    curBtn, 'click', {
                        placement: 'right-start'
                    }
                );
                //
                this.queryConfUIVisible = !this.queryConfUIVisible;
            },
            syncQueryConfUIVisible(visible) {
                this.queryConfUIVisible = visible;
                //
                if (visible) {
                    let queryConfPopover = this.getQueryConfPopover();
                    this.$nextTick(function () {
                        let confUIMaxHeight = $(window).height() - 40;
                        this.queryConfRef.setMaxHeight(confUIMaxHeight);
                        //
                        this.$nextTick(function () {
                            queryConfPopover.update();
                        });
                    });
                }
            },
            onQueryConfConfirm() {
                this.queryConfUIVisible = false;
                //
                this.liveQueryFields = this.queryConfRef.getMetaQueryFields();
                this.custQueryFields = this.queryConfRef.getCustQueryFields();
                //
                this.init(true);
            },
            onQueryConfCancel() {
                this.queryConfUIVisible = false;
                //
                this.$nextTick(function () {
                    this.liveQueryFields = Utils.merge([], this.liveQueryFields);
                    this.custQueryFields = Utils.merge([], this.custQueryFields);
                });
            },
            onSaveQueryConfInfo() {
                let custQueryFields = this.queryConfRef.getCustQueryFields();
                let widthCurValues = this.queryConfRef.getWidthCurValues();
                if (widthCurValues) {
                    keepFilterItemValues(custQueryFields, this.filterItems);
                } else {
                    clearFilterItemValues(custQueryFields);
                }
                //
                let custStorer = getQueryConfStorer();
                if (custStorer == null) {
                    console.error('自定义信息配置访问器未设置');
                } else {
                    let custConf = {
                        queryFields: JSON.encode(custQueryFields)
                    };
                    //
                    let self = this;
                    custStorer.saveCustQueryConf(this.confKey, custConf, function (success, message) {
                        self.$message({
                            type: success ? 'success' : 'warning',
                            message: message
                        });
                    });
                }
            },
            //------------------ 排序字段调整 -------------------
            getSortConfPopover() {
                return this.$refs['sortConfPopover'] || null;
            },
            showSortConfUI(event) {
                let curBtn = event.currentTarget;
                //
                let sortConfPopover = this.getSortConfPopover();
                sortConfPopover.bindToReferer(
                    curBtn, 'click', {
                        placement: 'right-start'
                    }
                );
                //
                this.sortConfUIVisible = !this.sortConfUIVisible;
            },
            syncSortConfUIVisible(visible) {
                this.sortConfUIVisible = visible;
                //
                if (visible) {
                    let sortConfPopover = this.getSortConfPopover();
                    this.$nextTick(function () {
                        let confUIMaxHeight = $(window).height() - 40;
                        this.sortConfRef.setMaxHeight(confUIMaxHeight);
                        //
                        this.$nextTick(function () {
                            sortConfPopover.update();
                        });
                    });
                }
            },
            onSortConfConfirm() {
                this.sortConfUIVisible = false;
                //
                this.liveSortFields = this.sortConfRef.getMetaSortFields();
                this.custSortFields = this.sortConfRef.getCustSortFields();
                //
                this.enabledSortFields = this.liveSortFields.filter(function (field) {
                    return field.enabled === true;
                });
                //
                this.triggerSortChange();
            },
            onSortConfCancel() {
                this.sortConfUIVisible = false;
                //
                this.$nextTick(function () {
                    this.liveSortFields = Utils.merge([], this.liveSortFields);
                    this.custSortFields = Utils.merge([], this.custSortFields);
                });
            },
            onSaveSortConfInfo() {
                let custSortFields = this.sortConfRef.getCustSortFields();
                //
                let custStorer = getQueryConfStorer();
                if (custStorer == null) {
                    console.error('自定义信息配置访问器未设置');
                } else {
                    let custConf = {
                        sortFields: JSON.encode(custSortFields)
                    };
                    //
                    let self = this;
                    custStorer.saveCustQueryConf(this.confKey, custConf, function (success, message) {
                        self.$message({
                            type: success ? 'success' : 'warning',
                            message: message
                        });
                    });
                }
            },
            showHisRecordsViewDlg() {
                if (typeof __hisRecordsViewDlgFunc == 'function') {
                    let dlgConf = {
                        confId: this.hisQueryId,
                        confName: this.hisQueryName,
                        excludedCtxNames: this.excludeHisQueryCtxNames || null
                    };
                    __hisRecordsViewDlgFunc(dlgConf);
                } else {
                    Toast.show('历史查询实现：' + this.hisQueryName);
                }
            },
            //-------------------------------------
            toFormItems(filterItems) {//查询条件信息
                let resultMap = {};
                let basicQueryFieldNames = this.basicQueryFields.pluck('code');
                let mappedQueryFields = this.mappedQueryFields;
                for (let code in filterItems) {
                    if (this.advQueryMode || basicQueryFieldNames.indexOf(code) != -1) {
                        //
                        let queryField = mappedQueryFields[code];
                        let label = queryField.label;
                        let fieldType = queryField.type;
                        let valueType = queryField.valueType;
                        let textValue = null;
                        if (this.rangedFieldNames.indexOf(code) != -1) {
                            textValue = '';
                            let valueRange = filterItems[code] || {};
                            //
                            if (fieldType == 'Date2' && valueType == 'Integer') {
                                if (valueRange.from != null) {
                                    textValue += '从 ' + formatIntegerDate(valueRange.from);
                                }
                                if (valueRange.to != null) {
                                    textValue += ' 到 ' + formatIntegerDate(valueRange.to);
                                }
                            } else {
                                if (valueRange.from != null) {
                                    textValue += '从 ' + valueRange.from;
                                }
                                if (valueRange.to != null) {
                                    textValue += ' 到 ' + valueRange.to;
                                }
                            }
                        } else {
                            let valueObj = filterItems[code];
                            if (fieldType == 'Popup') {
                                textValue = queryField.text || null;
                            } else if (fieldType == 'Checkbox') {
                                textValue = valueObj ? '是' : '否';
                            } else if (fieldType.isIn('Select', 'RadioGroup', 'Casc')) {
                                let dataList = queryField.dataList;
                                let dataLabel = queryField.dataLabel;
                                let dataValue = queryField.dataValue;
                                let multi = queryField.multiple;
                                textValue = extractTextFromDataListByValue(multi, dataList, valueObj, dataLabel, dataValue, fieldType == 'Casc');
                            } else if (fieldType == 'Month') {
                                textValue = formatYearMonth(valueObj);
                            } else if (fieldType == 'Date' && valueType == 'Integer') {
                                textValue = formatIntegerDate(valueObj);
                            } else {
                                textValue = valueObj;
                            }
                        }
                        //
                        if (textValue != null) {
                            resultMap[code] = {
                                label: label,
                                value: textValue + ''
                            };
                        }
                    }
                }
                //
                let resultItems = [];
                //理顺条件顺序
                let queryFields = null, queryFieldCodes = null;
                //basicQueryFields
                queryFields = this.basicQueryFields || [];
                queryFieldCodes = queryFields.pluck('code');
                for (let i = 0, c = queryFieldCodes.length; i < c; i++) {
                    let tempCode = queryFieldCodes[i];
                    let formItem = resultMap[tempCode];
                    if (formItem) {
                        resultItems.push(formItem);
                        delete resultMap[tempCode];
                    }
                }
                //extraQueryFields
                queryFields = this.extraQueryFields || [];
                queryFieldCodes = queryFields.pluck('code');
                for (let i = 0, c = queryFieldCodes.length; i < c; i++) {
                    let tempCode = queryFieldCodes[i];
                    let formItem = resultMap[tempCode];
                    if (formItem) {
                        resultItems.push(formItem);
                        delete resultMap[tempCode];
                    }
                }
                //
                return resultItems;
            },
            //
            toFilterItems(filterItems) {
                let resultItems = {};
                let basicQueryFieldNames = this.basicQueryFields.pluck('code');
                for (let code in filterItems) {
                    if (this.advQueryMode || basicQueryFieldNames.indexOf(code) != -1) {
                        if (this.rangedFieldNames.indexOf(code) != -1) {
                            let valueRange = filterItems[code] || {};
                            //
                            if (valueRange.from != null) {
                                resultItems[code + 'From'] = valueRange.from;
                            }
                            if (valueRange.to != null) {
                                resultItems[code + 'To'] = valueRange.to;
                            }
                        } else {
                            let tempValue = filterItems[code];
                            if (Utils.isArray(tempValue)) {
                                //去掉null值
                                for (let k = tempValue.length - 1; k >= 0; k--) {
                                    if (tempValue[k] == null) {
                                        tempValue.splice(k, 1);
                                    }
                                }
                            }
                            resultItems[code] = tempValue;
                        }
                    }
                }
                //
                return resultItems;
            },
            //forHisQry 专用
            toCondFields(filterItems) {
                let condFields = [];
                let condCtxMapping = {};
                //
                let liveQueryFieldNames = this.liveQueryFields.pluck('code');
                let basicQueryFieldNames = this.basicQueryFields.pluck('code');
                for (let i = 0, c = liveQueryFieldNames.length; i < c; i++) {
                    let code = liveQueryFieldNames[i];
                    let tempField = this.mappedQueryFields[code];

                    let retField = {
                        colName: tempField.code,
                        label: tempField.label,
                        valueType: tempField.valueType,
                        ctrlType: tempField.type
                    };

                    if (tempField.hidden && tempField.ctxBindName) {
                        //与上下文绑定的查询条件
                        retField.ctxBindName = tempField.ctxBindName;
                        condFields.push(retField);
                        //
                        condCtxMapping[code] = tempField.ctxBindName;
                    } else {
                        //有值的查询条件
                        let tempValue = filterItems[code];
                        if (tempValue != null && (this.advQueryMode || basicQueryFieldNames.indexOf(code) != -1)) {
                            if (this.formatItems[code]) {
                                retField.valueFormat = this.formatItems[code];
                            }
                            if (tempField.useLikeMatch != null) {
                                retField.useLikeMatch = tempField.useLikeMatch || false;
                            }
                            if (this.rangedFieldNames.indexOf(code) != -1) {
                                let valueRange = tempValue || {};
                                //
                                if (valueRange.from != null || valueRange.to != null) {
                                    if (retField.valueType == 'Date' && retField.valueFormat) {
                                        valueRange = Utils.merge(valueRange);
                                        if (valueRange.from != null && valueRange.from instanceof Date) {
                                            valueRange.from = valueRange.from.format(retField.valueFormat);
                                        }
                                        if (valueRange.to != null && valueRange.to instanceof Date) {
                                            valueRange.to = valueRange.to.format(retField.valueFormat);
                                        }
                                    }
                                    retField.valueRange = valueRange;
                                }
                            } else if (Utils.isArray(tempValue)) {
                                //去掉null值
                                for (let k = tempValue.length - 1; k >= 0; k--) {
                                    if (tempValue[k] == null) {
                                        tempValue.splice(k, 1);
                                    }
                                }
                                retField.valueList = tempValue;
                            } else {
                                if (retField.valueType == 'Date' && retField.valueFormat) {
                                    if (tempValue != null && tempValue instanceof Date) {
                                        tempValue = tempValue.format(retField.valueFormat);
                                    }
                                }
                                retField.value = tempValue;
                            }
                            condFields.push(retField);
                        }
                    }
                }
                //
                return {
                    condFields: condFields,
                    condCtxMapping: condCtxMapping
                };
            },
            toSortItemList(sortItems, asMap) {
                let enabledSortFields = this.enabledSortFields;
                if (asMap == true) {
                    let retMap = {};
                    for (let i = 0, c = enabledSortFields.length; i < c; i++) {
                        let field = enabledSortFields[i];
                        let code = field.code;
                        retMap[code] = sortItems[code];
                    }
                    return retMap;
                } else {
                    return enabledSortFields.map(function (field) {
                        let code = field.code;
                        return code + ':' + sortItems[code]
                    });
                }
            },
            //forHisQry 专用
            toSortFields(sortItems) {
                let enabledSortFields = this.enabledSortFields;
                return enabledSortFields.map(function (field) {
                    return {
                        colName: field.code,
                        label: field.label,
                        order: sortItems[field.code]
                    };
                });
            },
            callQueryHanlder(forSort = false) {
                forSort = forSort === true;
                //
                let model = this.getModel();
                if (this.forHisQry) {
                    this.lastQueryFilterItems = this.toFilterItems(this.filterItems);
                } else {
                    if (forSort) {//仅仅是排序变了
                        if (this.lastQueryFilterItems == null) {
                            this.lastQueryFilterItems = this.toFilterItems(this.filterItems);
                        }
                        model.filterItems = Utils.merge({}, this.lastQueryFilterItems); //不用最新的（而用旧的）
                    } else {
                        //更新缓存
                        this.lastQueryFilterItems = Utils.merge({}, model.filterItems);
                    }
                }
                //
                let queryHandler = this.queryHandler || null;
                if (typeof queryHandler == 'function') {
                    let queryContext = this.queryContext || this.parent || null;
                    //
                    queryHandler.call(queryContext, model);
                }
            },
            //================================================================================
            // 重置查询条件值
            clearFields(callQueryHanlderForcely /* 清除后是否强制调用 queryHandler */) {
                //重置查询结果（解决切换时恢复初始值的问题）
                this.filterItems = {};
                //
                this.eventDelayer.cancel();
                //标记初始化开始
                this.suspending = true;
                //
                let initFieldValues = Utils.merge(this.initFieldValues);
                let mappedQueryFields = this.mappedQueryFields;
                for (let fieldCode in mappedQueryFields) {
                    // 恢复初始值
                    let iniValue = initFieldValues[fieldCode];
                    let fieldInfo = mappedQueryFields[fieldCode];
                    fieldInfo.value = iniValue;
                    // 执行初始化
                    let queryFiedlCtrlName = this.makeQueryFieldVueCtrlName(fieldCode);
                    let queryFieldCtrl = this.$refs[queryFiedlCtrlName]; //[]
                    if (queryFieldCtrl != null && queryFieldCtrl.length > 0) {
                        queryFieldCtrl = queryFieldCtrl[0];
                        queryFieldCtrl.init();
                    }
                }
                //强制调用queryHanlder
                let self = this;
                this.eventDelayer.delay(function () {
                    self.notifyEvents(callQueryHanlderForcely);
                }, 300);
            },
            //更细查询字段的值或列表信息（防止死循环）
            //Select/RadioGroup/Casc :: code : {value, dataList, disabled, hidden} | dataList | value
            //Date2/Time2/Num2  :: code : { value : {from, to} , disabled, hidden} | { from, to , disabled, hidden}
            //Popup  :: code : { value , text , disabled, hidden}
            //其他   :: code : { value , disabled, hidden} | value
            updateFields(fieldInfoMap) {//{ code => ...}
                fieldInfoMap = fieldInfoMap || {};
                //
                this.eventDelayer.cancel();
                //标记初始化开始
                this.suspending = true;
                //
                let basicMapIndexes = this.basicMapIndexes;
                let basicQueryFields = this.basicQueryFields;
                let extraMapIndexes = this.extraMapIndexes;
                let extraQueryFields = this.extraQueryFields;
                let mappedQueryFields = this.mappedQueryFields;
                let dynaDataLists = this.dynaDataLists;
                //
                let fieldInfo = null;
                let fieldType = null;
                let fieldIndex = -1;
                let fieldList = null;
                let fieldChange = null;
                for (let fieldCode in fieldInfoMap) {
                    fieldInfo = mappedQueryFields[fieldCode];
                    if (fieldInfo == null) {
                        console.error('指定的查询字段(' + fieldCode + ')未定义');
                        continue;
                    }
                    fieldType = fieldInfo.type;
                    //
                    fieldIndex = basicMapIndexes[fieldCode];
                    if (fieldIndex == null) {
                        fieldIndex = extraMapIndexes[fieldCode];
                        if (fieldIndex == null) {
                            console.error('字段信息逻辑错乱');
                            continue;
                        }
                        fieldList = extraQueryFields;
                    } else {
                        fieldList = basicQueryFields;
                    }
                    //
                    let value = undefined;
                    let disabled = null;
                    let hidden = null;
                    fieldChange = fieldInfoMap[fieldCode];
                    if (fieldType == 'Select' || fieldType == 'RadioGroup' || fieldType == 'Casc') {
                        let dataList = null;
                        if (Utils.isPlainObject(fieldChange)) {
                            dataList = fieldChange['dataList'];
                            value = fieldChange['value'];
                            disabled = fieldChange['disabled'];
                            hidden = fieldChange['hidden'];
                        } else if (Utils.isArray(fieldChange)) {
                            dataList = fieldChange;
                        } else {
                            value = fieldChange;
                        }
                        if (dataList != null) {
                            fieldInfo.dataList = dataList;
                            dynaDataLists[fieldCode] = dataList || [];
                        }
                    } else if (fieldType == 'Date2' || fieldType == 'Time2' || fieldType == 'Month2' || fieldType == 'Num2') {
                        fieldChange = fieldChange || {};
                        value = fieldChange['value'];
                        if (value == null) {
                            let from = fieldChange['from'];
                            let to = fieldChange['to'];
                            if (typeof from != 'undefined' || typeof to != 'undefined') {
                                value = {};
                                if (typeof from != 'undefined') {
                                    value.from = from;
                                }
                                if (typeof to != 'undefined') {
                                    value.to = to;
                                }
                            }
                        }
                        disabled = fieldChange['disabled'];
                        hidden = fieldChange['hidden'];
                    } else if (fieldType == 'Popup') {
                        fieldChange = fieldChange || {};
                        let text = fieldChange['text'];
                        value = fieldChange['value'];
                        disabled = fieldChange['disabled'];
                        hidden = fieldChange['hidden'];
                        if (typeof text != 'undefined') {
                            fieldInfo.text = text;
                        }
                    } else {
                        if (Utils.isPlainObject(fieldChange)) {
                            value = fieldChange['value'];
                            disabled = fieldChange['disabled'];
                            hidden = fieldChange['hidden'];
                        } else {
                            value = fieldChange;
                        }
                    }
                    if (typeof value != 'undefined') {
                        fieldInfo.value = value;
                    }
                    if (disabled != null) {
                        fieldInfo.disabled = disabled;
                    }
                    if (hidden != null) {
                        fieldInfo.hidden = hidden;
                    }
                    this.$set(fieldList, fieldIndex, fieldInfo);
                }
                //
                this.eventDelayer.delay(this.notifyEvents, 300);
            },
            //获取查询条件、排序json模型
            getModel() {
                if (this.forHisQry) {
                    let condFldMap = this.toCondFields(this.filterItems);
                    let sortFields = this.toSortFields(this.sortItems);
                    return {
                        condCtxMapping: condFldMap.condCtxMapping,
                        condFields: condFldMap.condFields,
                        sortFields: sortFields
                    };
                } else {
                    let filterItems = this.toFilterItems(this.filterItems);
                    //
                    let sortItems = Utils.merge({}, this.sortItems);
                    let sortItemList = this.toSortItemList(sortItems);
                    let sortItemsX = this.toSortItemList(sortItems, true);
                    //
                    return {
                        filterItems: filterItems,
                        sortItemList: sortItemList,
                        //TODO delete
                        sortItems: sortItemsX
                    };
                }
            },
            getSortItemList() {//查询排序信息
                let sortItems = Utils.merge({}, this.sortItems);
                return this.toSortItemList(sortItems);
            },
            getFormItems() {//查询条件信息（导出用）
                return this.toFormItems(this.filterItems);
            },
            getLiveConfig() {
                let queryFields = Utils.merge(this.liveQueryFields);
                let sortFields = Utils.merge(this.liveSortFields);
                return {
                    queryFields: queryFields,
                    sortFields: sortFields
                };
            }
        }
    }

</script>
<style>
    .operation-btn-group {
        display: flex;
    }

    .query-btns .operation-btn-group .query-btn {
        border-radius: 4px;
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        cursor: pointer;
        color: #fff;
        background-color: #0c64eb;
        border-color: transparent;
        transition: .4s cubic-bezier(.175, .885, .32, 1);
    }

    .senior-btn {
        margin-left: 15px;
        cursor: pointer;

    }

    .query-items {
        max-height: 200px;
        overflow-y: auto;
    }

    .senior-btn .icon {
        color: #0c64eb;
        font-weight: 600;
        font-size: 20px;
    }

    .basic-block.show-more {
        padding-right: 0;
    }

    .query-btns.show-more {
        padding: 10px 0;
        position: relative;
    }

    .query-btns.show-more .operation-btn-group {
        justify-content: center;
    }

    .query-btns.show-more .other-more {
        position: absolute;
        top: 10px;
        right: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/query/QuerySortArea.vue